import React, { useEffect, useState } from "react";
import { saveAs } from "file-saver";
import {
  Document,
  Packer,
  Paragraph,
  TextRun,
  NumberFormat,
  Footer,
  AlignmentType,
  PageNumber,
  UnderlineType,
} from "docx";
import ImagePrint from "./PrintWord/ImagePrint";
import {
  imageDataGraphList,
  initialTableData,
  tableModelList,
} from "./DataModelConfig/DataTest";
import NewImageDocModal from "./NewFeatureModal/NewImageDocModal";
import ToolbarEditor from "./WordEditorComponents/ToolbarEditor";
import ImageView from "./WordEditorComponents/ImageView";
import BottomToolbarSetting from "./WordEditorComponents/BottomToolbarSetting";
import BottomToolbarView from "./WordEditorComponents/BottomToolbarView";
import { TableSwitchPrint } from "./TableWordUtils/TableSwitchPrint";
import { TableSwitchView } from "./TableWordUtils/TableSwitchView";
import NewTableDocModal from "./NewFeatureModal/NewTableDocModal";
import EditTableDataModal from "./WordEditorComponents/EditTableDataModal";
import NewParagraphDocModal from "./NewFeatureModal/NewParagraphDocModal";
import ParagraphPrint from "./PrintWord/ParagraphPrint";
import useChapterStore from "../../store/zustandStore/chapterZs";
import { loadImageUrlById } from "../../store/uploadFile";
import { useDispatch, useSelector } from "react-redux";
import { getYearReport } from "./Utils/useYearRaport";

const TypeDocInstance = {
  paragraph: { lable: "Paragraf", value: "paragraph" },
  table: { lable: "Tabele", value: "table" },
  image: { lable: "Imazh", value: "image" },
};

const Editor = (props) => {
  const {
    chaptersZs,
    fetchChaptersZs,
    deleteChapterZs,
    getChapterZs,
    chapterZs,
    updateChapterZs,
  } = useChapterStore();

  const yearReport = getYearReport();

  const [content, setContent] = useState([]);
  const [headers, setHeaders] = useState([
    "Oshma",
    "Adresa",
    "Telefoni",
    "Emaili",
  ]);

  const [openEditTableModal, setEditTableModal] = useState(false);
  const [editTable, setEditTable] = useState([]);
  const [loading, setLoading] = useState(true); // Loading state
  const [newImageDocModal, setNewImageDocModal] = useState(false);
  const [newTableDocModal, setNewTableDocModal] = useState(false);
  const [newPargraphDocModal, setNewParagraphDocModal] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true); // Start loading
      await getChapterZs(props?.chapter?.id); // Fetch chapter data
      setLoading(false); // Finish loading
    };

    fetchData(); // Call the fetch function
  }, [props?.chapter?.id]);

  useEffect(() => {
    if (chapterZs?.content) {
      setContent(chapterZs?.content); // Set the content after fetching
    } else {
      setContent([]); // If no content, set it as an empty array
    }
  }, [chapterZs]);

  // Edit content
  const editContent = (id, key, value) => {
    setContent(
      content.map((item) => (item.id === id ? { ...item, [key]: value } : item))
    );
  };

  // Edit table headers
  const editHeader = (id, index, value) => {
    setContent(
      content.map((item) =>
        item.id === id && item.type === "table"
          ? {
              ...item,
              tableHeaders: item.tableHeaders.map((h, i) =>
                i === index ? value : h
              ),
            }
          : item
      )
    );
  };

  // Delete content
  const deleteContent = (id) => {
    setContent(content.filter((item) => item.id !== id));
  };

  // Move content up or down
  const moveContent = (index, direction) => {
    if (
      (direction === -1 && index === 0) ||
      (direction === 1 && index === content.length - 1)
    )
      return;
    const newContent = [...content];
    [newContent[index], newContent[index + direction]] = [
      newContent[index + direction],
      newContent[index],
    ];
    const updatedContent = newContent.map((item, idx) => ({
      ...item,
      order: idx + 1, // order starts from 1
    }));

    setContent(updatedContent);
  };
  const updateParagraph = (id, title = false) => {
    setContent(
      content.map((item) =>
        item.id === id ? { ...item, textSetting: { title: title } } : item
      )
    );
  };

  const handleUpdateTableDoc = (data) => {
    setEditTableModal(false);
    editContent(editTable.id, "tableContent", data);
  };

  // Export to Word
  const exportToWord = async () => {
    const docChildren = [];

    for (const item of content) {
      if (item.type === "paragraph") {
        docChildren.push(new Paragraph({ children: [new TextRun("")] }));
        // docChildren.push(
        //   new Paragraph({
        //     style: "arial",
        //     children: [new TextRun(item.text)],
        //   })
        // );
        docChildren.push(await ParagraphPrint(item));
        docChildren.push(new Paragraph({ children: [new TextRun("")] }));
      } else if (item.type === "table") {
        docChildren.push(new Paragraph({ children: [new TextRun("")] }));
        docChildren.push(...(await TableSwitchPrint(item))); // HERE ADD Table
        // docChildren.push(TableSwitchPrint2(item));
        docChildren.push(new Paragraph({ children: [new TextRun("")] }));
      } else if (item.type === "image" && item.imageURL) {
        docChildren.push(new Paragraph({ children: [new TextRun("")] }));
        docChildren.push(await ImagePrint(item));
        docChildren.push(new Paragraph({ children: [new TextRun("")] }));
      }
    }
    const doc = new Document({
      styles: {
        default: {
          document: {
            run: {
              font: "Arial", // Set Arial as the default font
              size: 24, // 12pt
            },
          },
        },

        paragraphStyles: [
          {
            id: "wellSpaced",
            name: "Arial",
            font: "Arial",
            basedOn: "Normal",
            run: {
              size: 22,
              bold: true,
              color: "e41e26",
            },
            quickFormat: true,
            // paragraph: {
            //   spacing: {
            //     line: 276,
            //     before: 20 * 72 * 0.1,
            //     after: 20 * 72 * 0.05,
            //   },
            // },
          },
          {
            id: "arial",
            name: "Arial",
            font: "Arial",
            basedOn: "Normal",
            run: {
              size: "12pt",
            },
            quickFormat: true,
            paragraph: {
              spacing: {
                line: 276,
                before: 20 * 72 * 0.1,
                after: 20 * 72 * 0.05,
              },
            },
          },
          {
            id: "strikeUnderline",
            name: "Strike Underline",
            basedOn: "Normal",
            quickFormat: true,
            run: {
              strike: true,
              underline: {
                type: UnderlineType.SINGLE,
              },
            },
          },
        ],
      },
      sections: [
        {
          properties: {
            page: {
              pageNumbers: {
                start: 1,
                formatType: NumberFormat.DECIMAL,
              },
            },
          },
          footers: {
            default: new Footer({
              children: [
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      children: ["AMA"],
                    }),
                  ],
                }),
                new Paragraph({
                  // style: "wellSpaced",
                  alignment: AlignmentType.RIGHT,
                  children: [
                    new TextRun({
                      // children: [PageNumber.CURRENT],

                      children: [
                        PageNumber.CURRENT, // Numri i faqes
                      ],
                      color: "FF0000", // E kuqe (hex)
                      font: "Arial",
                      size: 24,
                      style: "Normal",
                    }),
                  ],
                }),
              ],
            }),
          },
          children: docChildren,
        },
      ],
    });
    const blob = await Packer.toBlob(doc);
    saveAs(blob, "document.docx");
  };

  const addNewImageContent = (item) => {
    const newItem = {
      id: Date.now(),
      order: content.length + 1,
      type: "image",
      imageURL: item?.file?.id,
      fileId: item.fileId,
      imageURL: item.fileId,
      imageLabel: item.label,
      imageSetting: {
        height: 500,
        width: 500,
      },
    };
    setContent([...content, newItem]);
  };

  const addNewTableContent = (item) => {
    const newItem = {
      id: Date.now(),
      order: content.length + 1,
      type: "table",
      formId: item?.formId ?? "",
      typeFormId: item?.typeFormId ?? "SIMPLE",
      tableHeaders: [...headers],
      tableContent: item.data,
      tableLabel: item.label,
      customTableHeader: [{ cell1: "Header 1-1", cell2: "Header 2-2" }],
      tableSetting: {
        model: {
          id: item.modelId,
          label: item.modelLabel,
        },
        headerBackground: "f44336",
        headerColor: "FFFFFF",
      },
      formulaId: item?.formulaId,
      year: yearReport,
      formFormulaType: item?.formFormulaType,
      postProcessing: item.postProcessing ?? null,
      apiEndpoint: item?.apiEndpoint ?? "",
    };
    setContent([...content, newItem]);
  };

  const addNewParagraphContent = (item) => {
    const newItem = {
      id: Date.now(),
      order: content.length + 1,
      type: "paragraph",
      text: item,
      textSetting: { title: false },
    };
    setContent([...content, newItem]);
  };

  const handleSaveChapter = () => {
    const chapterUpdate = { ...chapterZs, content: content };
    updateChapterZs(chapterUpdate);
  };

  if (loading) {
    return <div>Duke u ngarkuar...</div>; // Show a loading message while data is being fetched
  }

  return (
    <div style={{ padding: "20px", maxWidth: "1000px", margin: "auto" }}>
      <h2>Dokument Editor</h2>
      {/* <button onClick={handleOnloadImage}>get image</button> */}
      <ToolbarEditor // Toolbar Document Editor
        // onAddParagraph={() => addNewParagraphContent("")}
        onAddParagraph={() => setNewParagraphDocModal(true)}
        onAddTable={() => setNewTableDocModal(true)}
        onAddImage={() => setNewImageDocModal(true)}
        onExportWord={exportToWord}
        onSave={handleSaveChapter}
      />
      {/* Content List */}
      {content.map((item, index) => (
        <div
          key={item.id}
          style={{
            marginTop: "10px",
            padding: "10px",
            border: "1px solid #ddd",
          }}
        >
          <strong>Tipi: {TypeDocInstance[item.type].lable}</strong>

          {item.type === "paragraph" && (
            <div>
              <textarea
                value={item.text}
                onChange={(e) => editContent(item.id, "text", e.target.value)}
                style={{
                  width: "100%",
                  fontStyle: "Arial",
                  fontSize: item?.textSetting?.title ? "20px" : "16px",
                  padding: "6px",
                  borderRadius: "8px",
                  minHeight: "80px",
                  color: item?.textSetting?.title ? "red" : "black",
                }}
              />
              <div style={{ display: "flex" }}>
                <button
                  style={{
                    background: item?.textSetting?.title
                      ? "#ffffaa"
                      : "transparent",
                    borderRadius: "4px",
                    border: "1px solid gray",
                  }}
                  onClick={(e) => updateParagraph(item.id, true)}
                >
                  Titull
                </button>
                <button
                  style={{
                    background: item?.textSetting?.title
                      ? "transparent"
                      : "#ffffaa",
                    borderRadius: "4px",
                    border: "1px solid gray",
                  }}
                  onClick={(e) => updateParagraph(item.id, false)}
                >
                  Kontent
                </button>
              </div>
            </div>
          )}

          {item.type === "table" && (
            <div>
              {/* Editable Headers */}
              {/* <div
                style={{ display: "flex", gap: "10px", marginBottom: "10px" }}
              >
                {item.tableHeaders.map((header, i) => (
                  <input
                    key={i}
                    value={header}
                    onChange={(e) => editHeader(item.id, i, e.target.value)}
                    style={{ flex: 1, padding: "5px" }}
                  />
                ))}
              </div> */}
              {/* Static Table Preview */}

              <TableSwitchView data={item} />
            </div>
          )}
          {item.type === "image" && (
            <ImageView
              imageLabel={item.imageLabel}
              imageURL={item.imageURL}
              fileId={item.fileId}
              // imageURL={imageUrl}
              onChangeImageUrl={(e) =>
                editContent(item.id, "imageURL", e.target.value)
              }
              height={item?.imageSetting?.height}
              width={item?.imageSetting?.width}
            />
          )}
          {/* Settings of View, Move & Delete Buttons */}
          <BottomToolbarView
            type={item.type}
            onChangeTable={() => {
              setEditTableModal(true);
              setEditTable(item);
            }}
            onImageDimensionChange={(dimensions) =>
              editContent(item.id, "imageSetting", dimensions)
            }
            item={item}
            content={content}
            onDeleteContent={() => deleteContent(item.id)}
            onMoveUpContent={() => moveContent(index, -1)}
            onMoveDownConent={() => moveContent(index, 1)}
            // onCustomTableHeader={()}
            index={index}
          />
        </div>
      ))}

      <EditTableDataModal
        isOpen={openEditTableModal}
        onClose={() => setEditTableModal(false)}
        dataProps={editTable}
        onUpdateTableDoc={handleUpdateTableDoc}
      />
      <NewImageDocModal
        isOpen={newImageDocModal}
        onSelect={(e) => addNewImageContent(e)}
        onClose={() => {
          setNewImageDocModal(false);
        }}
        year={yearReport}
        dataList={imageDataGraphList}
      />
      <NewTableDocModal
        isOpen={newTableDocModal}
        onSelect={(e) => addNewTableContent(e)}
        onClose={() => {
          setNewTableDocModal(false);
        }}
        year={yearReport}
        dataList={tableModelList}
      />
      <NewParagraphDocModal
        isOpen={newPargraphDocModal}
        // onSelect={(e) => addNewTableContent(e)}
        onClose={() => {
          setNewParagraphDocModal(false);
        }}
        onSave={addNewParagraphContent}
        // onNewValue={addNe}
      />
    </div>
  );
};

export default Editor;
